import React, {Component, useState, useEffect, useContext}  from 'react'
import {View, Text, StyleSheet, Image, Dimensions} from 'react-primitives'
import { Link } from 'react-router-dom';

function Chat (props) {

    return (
        <View>
            <Text>OMG the CHAT</Text>
        </View>
    )
}

export default Chat 


// WEBPACK FOOTER //
// ./src/screens/chat.js